import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const DESKTOP_MOVE_PERSONALIZED_RECS_ATF_TEST_NAME = 'desktopMovePersonalizedRecsAtf';
const MW_MOVE_PERSONALIZED_RECS_ATF_TEST_NAME = 'mwMovePersonalizedRecsAtf';

export const getPersonalizedContentAboveFoldTestName = (isMobile: boolean): string =>
    isMobile
        ? MW_MOVE_PERSONALIZED_RECS_ATF_TEST_NAME
        : DESKTOP_MOVE_PERSONALIZED_RECS_ATF_TEST_NAME;

export const trackPersonalizedContentAboveFoldTest = (isMobile: boolean): void => {
    trackAbTestV2Variant(getPersonalizedContentAboveFoldTestName(isMobile));
};
